import React from 'react'

import {AddUser_Manager} from "../../model/manager"
import UserToAdd from "../../model/add-user"
import CheckBox, {CheckboxType} from "../../../../gd-components/checkbox/checkbox"
import UserIcon from "../../../../gd-components/icons/user/user"
import ModalAddUser_SectionMoreButton from "./section-more/more-button"
import ModalAddUser_MeetingRoleCell from "./meeting-role-cell"
import FieldFormElementView from "../../../../fields3/render/form-elemnent-view"
import {ProjectAccess} from "../../../../gd/const/project"
import FieldProjectAccess from "../../../../fields3/system/project/access/project-access"
import {ProjectAccessMode} from "../../../../model2/project/types"

type Props = {
    className?          : string

    manager             : AddUser_Manager
    showProjectAccess?  : boolean
    showWorkspaceAccess?: boolean
    showMeetingRole?    : boolean
}


export default function ModalAddUser_AddToWorkspace(props: Props) {

    const isMultiselectEnabled = props.manager.multiselect
    const isInheritanceChildren = props.manager.workspace?.project.accessMode === ProjectAccessMode.INHERITANCE_CHILDREN

    const toggleUser = (userToAdd:UserToAdd) => {
        if (!isMultiselectEnabled) {
            props.manager.unselectAll()
        }

        userToAdd.toggleIsSelected()
        props.manager.reRender()
    }

    const onWorkspaceAccessChange = (userToAdd:UserToAdd, access:ProjectAccess) => {
        userToAdd.workspaceAccess = access
        if (isInheritanceChildren) {
            // project access can't be lower than workspace access in INHERITANCE_CHILDREN
            if (!userToAdd.projectAccess || userToAdd.projectAccess < userToAdd.workspaceAccess) {
                userToAdd.projectAccess = userToAdd.workspaceAccess
            }
        }

        props.manager.reRender()
    }

    const onProjectAccessChange = (userToAdd:UserToAdd, access:ProjectAccess) => {
        userToAdd.projectAccess = access
        props.manager.reRender()
    }

    return (
        <>
            <div className={Classes("ui5-tabled-dashed w-100p", props.className)}>
                <div className="table-header">
                    <div className="cell flex-1 flex-row-left-center">
                        <div className="ifl-ac show-hidden-on-hover">
                            <div className="ui5-title-small">
                                Company Users
                            </div>

                            <ModalAddUser_SectionMoreButton
                                className   = "m-l-5"
                                manager     = {props.manager}
                                usersToAdd  = {props.manager.companyUsersToAdd}
                            />
                        </div>
                    </div>

                    {props.showWorkspaceAccess &&
                        <div className="cell w-160">
                            {props.manager.companyUsersToAdd.atLeastOneChecked &&
                                <div className="ui5-grid-header">
                                    Workspace Access
                                </div>}
                        </div>}

                    {props.showProjectAccess &&
                        <div className="cell w-160">
                            {props.manager.companyUsersToAdd.atLeastOneChecked &&
                                <div className="ui5-grid-header">
                                    Project Access
                                </div>}
                        </div>}

                    {props.showMeetingRole &&
                        <div className="cell w-160">
                            {props.manager.companyUsersToAdd.atLeastOneChecked &&
                                <div className="ui5-grid-header">
                                    Meeting Role
                                </div>
                            }
                        </div>
                    }
                </div>

                {_.isEmpty(props.manager.companyUsersToAdd.available) &&
                    <div className="table-row">
                        <div className="flex-row-center-center ui5-txt-not-important">
                            No users found
                        </div>
                    </div>}

                {_.map(props.manager.companyUsersToAdd.available, (userToAdd:UserToAdd, key:number)=>{
                    const rowClasses = Classes("table-row", {
                        'ui5-bg-gray'   : userToAdd.isSelected,
                        'p-l-5'         : !isMultiselectEnabled
                    })

                    const projectAccessField = _.cloneDeep(props.manager.projectAccessField) as FieldProjectAccess
                    // project access can't be lower than workspace access in INHERITANCE_CHILDREN
                    if (props.manager.workspace?.project.accessMode === ProjectAccessMode.INHERITANCE_CHILDREN) {
                        projectAccessField.minAccess = userToAdd.workspaceAccess
                    }

                    return (
                        <div className={rowClasses} key={key} onClick={toggleUser.bind(null, userToAdd)} >
                            <div className="cell flex-1 flex-row-left-center">
                                {isMultiselectEnabled &&
                                    <CheckBox className = "m-r-10 m-l-5"
                                              type      = {CheckboxType.FILLED}
                                              isChecked = {userToAdd.isSelected} />}
                                <UserIcon size="22" userId={userToAdd.id} className="m-r-8" />
                                <div className="ui5-txt-default">{userToAdd.user.name}</div>
                            </div>

                            {props.showWorkspaceAccess &&
                                <div className="cell w-160">
                                    {userToAdd.isSelected &&
                                        <FieldFormElementView className = "w-140"
                                                              field     = {props.manager.workspaceAccessField}
                                                              options   = {{size: '30'}}
                                                              model     = {userToAdd}
                                                              onChange  = {onWorkspaceAccessChange.bind(null, userToAdd)}/>}
                                </div>}

                            {props.showProjectAccess &&
                                <div className="cell w-160">
                                    {userToAdd.isSelected &&
                                        <FieldFormElementView className = "w-140"
                                                              field     = {projectAccessField}
                                                              options   = {{size: '30'}}
                                                              model     = {userToAdd}
                                                              onChange  = {onProjectAccessChange.bind(null, userToAdd)}/>}
                                </div>}

                            {props.showMeetingRole &&
                                <ModalAddUser_MeetingRoleCell
                                    manager     = {props.manager}
                                    userToAdd   = {userToAdd}
                                />
                            }
                        </div>
                    )
                })}
            </div>
        </>
    )
}
